/**
 * The leg rule every chamfer edit shares (room corners, free-element corners,
 * alcove outer corners): each given leg is rounded to the half inch and
 * clamped to [0, its maximum]; a leg left out keeps its value.
 */
import { clamp, roundToHalfInch } from '../constraints';
import type { FloorPlanCorner } from '../schemas';

/** The legs a chamfer edit sets; a leg left out keeps its current value. */
export interface ChamferLegs {
  dx?: number;
  dy?: number;
}

/** No maximum: an alcove grows to fit its outer chamfer instead. */
export const UNBOUNDED_LEGS = { dx: Infinity, dy: Infinity };

/** The corner with `legs` applied, or the same corner when neither leg changes. */
export function chamferAfterEdit(corner: FloorPlanCorner, legs: ChamferLegs, maxLegs: { dx: number; dy: number }): FloorPlanCorner {
  const dx = legs.dx != null ? clamp(roundToHalfInch(legs.dx), 0, maxLegs.dx) : corner.dx;
  const dy = legs.dy != null ? clamp(roundToHalfInch(legs.dy), 0, maxLegs.dy) : corner.dy;
  return dx === corner.dx && dy === corner.dy ? corner : { ...corner, dx, dy };
}
